import React, { useCallback, useEffect, useRef, useState } from 'react'
import LearningDynamicTable from './LearningDynamicTable'
import { useDispatch, useSelector } from 'react-redux';
import { fetchFileRecordsRequest, fileUploadRequest, getFileHeadersRequest, updateColumnVisibilityRequest, updateDataCenterId } from 'src/containers/data-center-container/Data-center/actions/DataCenterActions';
import SheetUploadModal from './SheetUploadModal';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFileHeaderIdAPI, getRecentFileDataAPI, updateFileHeaderAPI, updateUidHeaderAPI } from 'src/api/DataCenterApi';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
const LearningDevelopment = () => {
  const { dataCenterId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const containerRef = useRef();
  const fileUploadState = useSelector((state) => state.dataCenter.fileUpload);
  const { totalRecords } = useSelector((state) => state.dataCenter.fileRecords);
  const [sheetUrl, setSheetUrl] = useState('')
  const [showModal, setShowModal] = useState(false);
  const { data: tableData, columns, loading, headerId } = useSelector(
    (state) => state.dataCenter?.fileRecords
  );
  const { loading: fileUploadLoading } = useSelector(state => state.dataCenter?.fileUpload)
  const [columnVisibility, setColumnVisibility] = useState({});
  const [uniqueId, setUniqueId] = useState('');
  const [viewManageColumn, setViewManageColumn] = useState(false)
  const offcanvasRef = useRef(null);
  const [downloadInOneSheet, setDownloadInOneSheet] = useState(true);
  const [fileDownloadCount, setFileDownloadCount] = useState(100);
  const [searchValue, setSearchValue] = useState('')
  const [filteredList, setFilteredList] = useState([]);
  const [hasMoreRecords, setHasMoreRecords] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [totalPages, setTotalPages] = useState(0)

  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageLength: 100000,
  });

  useEffect(() => {
    dispatch(updateDataCenterId(dataCenterId))
  }, [dataCenterId])

  useEffect(() => {
    const uidColumn = columns.find(col => col.isUid === true);
    setUniqueId(uidColumn ? uidColumn.fieldName : '');
  }, [columns]);

  // useEffect(() => {
  //   if (totalRecords > 0) {
  //     setTotalPages(Math.ceil(totalRecords / pagination.pageLength));
  //   }
  // }, [totalRecords]);


  const closeManageColumn = () => {
    setViewManageColumn(false)
  }

  const handleToggleDownloadSheet = () => {
    setDownloadInOneSheet(prev => !prev);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (offcanvasRef.current && !offcanvasRef.current.contains(event.target)) {
        closeManageColumn();
      }
    }

    if (viewManageColumn) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewManageColumn, closeManageColumn]);


  useEffect(() => {
    if (columns?.length) {
      const initialVisibility = {};
      columns.forEach(col => {
        initialVisibility[col.order] = col.visible ?? true;
      });
      setColumnVisibility(initialVisibility);
    }
  }, [columns]);

  useEffect(() => {
    if (!dataCenterId) {
      navigate('/DataCenter');
    }
  }, [dataCenterId, navigate]);

  // const loadData = useCallback(() => {
  const loadData = () => {
    console.log('called')
    if (isFetching || pagination.currentPage >= totalPages) {
      return;
    }

    setIsFetching(true);
    // dispatch(fetchFileRecordsRequest({ dataCenterId, currentPage: pagination.currentPage + 1 }))
    dispatch(fetchFileRecordsRequest({ dataCenterId }))
      .finally(() => setIsFetching(false));
  };
  // }, [pagination.currentPage, totalPages, isFetching, dispatch, dataCenterId]);

  useEffect(() => {
    dispatch(fetchFileRecordsRequest({
      dataCenterId,
      ...pagination
    }));
  }, [dataCenterId, pagination.currentPage, pagination.pageSize]);

  const handlePageChange = (newPage, pageSize) => {
    setPagination(prev => ({
      ...prev,
      currentPage: newPage,
      pageLength: pageSize,
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 5) {
        loadData();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    if (pagination.currentPage >= totalPages || tableData.length === 0) {
      setHasMoreRecords(false);
    }
  }, [pagination.currentPage, totalPages, tableData]);

  const handleSheetUrlChange = (event) => {
    setSheetUrl(event.target.value);
  };

  const handleSheetUpload = () => {
    if (!sheetUrl || sheetUrl === '') {
      return toast.error('Sheet Url is required')
    }
    dispatch(getFileHeadersRequest({ sheetUrl }));
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false);
    setSheetUrl('')
  }

  const handleSaveView = async () => {
    if (!columns?.length) return;
    const updatedColumns = columns.map(col => ({
      ...col,
      visible: columnVisibility[col.order] ?? true
    }));
    dispatch(updateColumnVisibilityRequest(updatedColumns));
    setViewManageColumn(false)
    try {
      const res = await getFileHeaderIdAPI(headerId, uniqueId)
      if (res?.data?.success) {
        const fieldHeaderId = res?.data?.data?.headerId

        let updatedHeader = {
          headerId: fieldHeaderId,
          updates: {
            headerValue: uniqueId,
            isUid: true
          }
        }
        const response = await updateUidHeaderAPI(headerId, updatedHeader)
        dispatch(fetchFileRecordsRequest({ dataCenterId }));
      }
    } catch (error) {
      console.log('error:', error)
    }
  };


  const handleUidChange = (e) => {
    setUniqueId(e.target.value)
  };

  const handleManageColumn = () => {
    setViewManageColumn(true)
  }

  const handleBack = () => {
    navigate(-1);
  }

  const handleDownload = async (shouldSplit = false, rowsPerFile = 100) => {
    try {
      const res = await getRecentFileDataAPI(dataCenterId);
      const fileUrl = res?.data?.data?.fileUrl;
      const fileName = res?.data?.data?.fileName;
      console.log('fileName', fileName)

      if (!fileUrl) {
        console.error('No file URL found in response.');
        return;
      }

      const response = await fetch(fileUrl);
      const csvText = await response.text();

      if (!shouldSplit) {
        console.log('here')
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        return;
      }
      const lines = csvText.split('\n');
      const header = lines[0];
      const dataLines = lines.slice(1);

      for (let i = 0; i < dataLines.length; i += rowsPerFile) {
        const chunk = [header, ...dataLines.slice(i, i + rowsPerFile)].join('\n');
        const blob = new Blob([chunk], { type: 'text/csv' });
        const chunkUrl = URL.createObjectURL(blob);
        const chunkLink = document.createElement('a');
        chunkLink.href = chunkUrl;
        chunkLink.download = `${fileName.replace('.csv', '')}_part${Math.floor(i / rowsPerFile) + 1}.csv`;
        document.body.appendChild(chunkLink);
        chunkLink.click();
        document.body.removeChild(chunkLink);
        URL.revokeObjectURL(chunkUrl);
      }
    } catch (error) {
      console.error('Export failed:', error);
    }
  };

  if (!dataCenterId) return null;



  const onDragEnd = async (result) => {
    if (!result.destination) return;
    
    const items = Array.from(columns);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    // Update the order property based on new position
    const updatedColumns = items.map((col, index) => ({
      ...col,
      order: index
    }));
    
    // try {
    //   // Update local state first for immediate UI feedback
    //   dispatch(updateColumnsOrderRequest(updatedColumns));
      
    //   // Make API call to persist the new order
    //   await updateColumnOrderAPI(headerId, updatedColumns);
      
    //   toast.success('Column order updated successfully');
    // } catch (error) {
    //   console.error('Failed to update column order:', error);
    //   toast.error('Failed to update column order');
    //   // Optionally dispatch an action to revert to previous columns order
    // }
  };

  return (
    <div>
      <div className="row">
        <div className="col-xxl-12 col-xl-12">
          <div className="card h-100">
            <div className="card-body p-24">
              <h2 className="fw-semibold mb-16 d-flex align-items-center gap-4 font-24">
                <button
                  onClick={handleBack}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width={30}
                    height={30}
                  >
                    <g data-name="20-Arrow Left">
                      <path
                        fill="#0073ea"
                        d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
                      />
                      <path
                        fill="#0073ea"
                        d="m8.41 15 5.29-5.29-1.41-1.42-7 7a1 1 0 0 0 0 1.41l7 7 1.41-1.41L8.41 17H27v-2z"
                      />
                    </g>
                  </svg>
                </button>{" "}
                Learning &amp; Development
              </h2>
              <ul className="d-flex align-items-center gap-2">
                <li className="fw-medium">
                  <a
                    href="index-2.html"
                    className="d-flex align-items-center gap-1 hover-text-primary"
                  >
                    <iconify-icon
                      icon="solar:home-smile-angle-outline"
                      className="icon text-lg"
                    ></iconify-icon>
                    Special Access
                  </a>
                </li>
                <li>-</li>
                <li className="fw-medium">Data Center</li>
                <li>-</li>
                <li className="fw-medium">Learning &amp; Development</li>
              </ul>
              <div className="devdivider" />
              <form className="example googleSheet-url" action="/action_page.php">
                <input
                  type="text"
                  placeholder="Enter or Paste Google Spreadsheets URL here..."
                  name="search"
                  value={sheetUrl}
                  onChange={handleSheetUrlChange}
                />
                <button
                  type="button"
                  className=""
                  // data-bs-toggle="modal"
                  // data-bs-target="#googlesheet"
                  onClick={handleSheetUpload}
                >
                  Upload URL
                </button>
              </form>
              <div className="d-flex align-items-center py-16 justify-content-between flex-wrap">
                <div className="d-flex gap-2 align-items-center">
                  {/* Search start */}
                  <div className="search w-25">
                    <span className="searchBtn position-absolute end-0 top-50 translate-middle-y me-12 line-height-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeMiterlimit={10}
                          strokeWidth={32}
                          d="M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64Z"
                        ></path>
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeMiterlimit={10}
                          strokeWidth={32}
                          d="M338.29 338.29L448 448"
                        ></path>
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="search"
                      placeholder="Search"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                  </div>
                  {/* Search End */}
                  {/* Manage Column btn start */}
                  <div className="FilterBtn">
                    <button
                      type="button"
                      // data-bs-toggle="offcanvas"
                      // data-bs-target="#manageColRightPopup"
                      // aria-controls="manageColRightPopup"
                      className="btn btn-outline-primary-600 grbtn heightAllBtnSet44 text-sm radius-8 px-20 py-9 d-flex align-items-center gap-2"
                      onClick={handleManageColumn}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        fill="currentColor"
                        className="bi bi-columns"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm8.5 0v8H15V2zm0 9v3H15v-3zm-1-9H1v3h6.5zM1 14h6.5V6H1z"></path>
                      </svg>{" "}
                      Manage Column
                    </button>
                  </div>
                  {/* Manage Column btn end */}
                </div>
                {/* start Export Button  */}
                <div className="exportBtn">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exportSheet"
                  >
                    Export{" "}
                    <img
                      className="img-fluid"
                      src="/assets/images/data-center/excel-sheet-icon.svg"
                    />
                  </button>
                </div>
                {/* End Export Button  */}
              </div>
              {/* Start Table Sec  */}
              <div>
                {(fileUploadLoading) ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <LearningDynamicTable containerRef={containerRef} dataCenterId={dataCenterId} searchTerm={searchValue} />
                )}
              </div>
              {/* End Table Sec  */}
            </div>
          </div>
        </div>
      </div>



      <>
        {/* start Sheet Update Popup  */}
        {showModal && (
          <SheetUploadModal closeModal={closeModal} sheetUrl={sheetUrl} dataCenterId={dataCenterId} />
        )}
        {/* End Sheet Update Popup  */}
      </>


      



      <>
        {/* start Export Sheet Popup  */}
        <div
          className="modal fade exportPopSec"
          id="exportSheet"
          tabIndex={-1}
          aria-labelledby="exportSheetLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exportSheetLabel">
                  Modal title
                </h1>
                <span data-bs-dismiss="modal" aria-label="Close">
                  <svg
                    width={16}
                    height={15}
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 6.3216L14.0778 0.243764C14.4029 -0.0812545 14.9312 -0.0812545 15.2562 0.243764C15.5813 0.568782 15.5813 1.09714 15.2562 1.42216L9.1784 7.5L15.2562 13.5778C15.5813 13.9029 15.5813 14.4312 15.2562 14.7562C14.9312 15.0813 14.4029 15.0813 14.0778 14.7562L8 8.6784L1.92216 14.7562C1.59714 15.0813 1.06878 15.0813 0.743764 14.7562C0.418745 14.4312 0.418745 13.9029 0.743764 13.5778L6.8216 7.5L0.743764 1.42216C0.418745 1.09714 0.418745 0.568782 0.743764 0.243764C1.06878 -0.0812545 1.59714 -0.0812545 1.92216 0.243764L8 6.3216Z"
                      fill="#323338"
                    />
                  </svg>
                </span>
              </div>
              <div className="modal-body">
                <div className="sheetPopuDivider" />
                <div className="contentAddColsSec exportHeading">
                  <h6>Total Result:</h6>
                  <h5>{totalRecords}</h5>
                </div>
                <div className="contentAddColsSec">
                  <label htmlFor="" className="toggleText">
                    Download all data in one sheet
                  </label>
                  <label className="switchSmall m5">
                    <input type="checkbox"
                      checked={downloadInOneSheet}
                      onChange={handleToggleDownloadSheet}
                    />
                    <small />
                  </label>
                </div>
                {!downloadInOneSheet ?
                  <div className="contentAddColsSec d-block exportIput">
                    <label htmlFor="" className="toggleText form-label mb-0">
                      Number of Data in one sheet
                    </label>
                    <input
                      type="number"
                      id="number"
                      className="form-control"
                      placeholder="Enter Number"
                      value={fileDownloadCount}
                      onChange={(e) => setFileDownloadCount(e.target.value)}
                    />
                  </div> : null}
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  data-bs-dismiss="modal"
                  onClick={() => handleDownload(!downloadInOneSheet, fileDownloadCount)}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* End Export Sheet Popup  */}
      </>


      <>
        {/* start Delete cols Popup  */}
        <div
          className="modal fade deleteColsSec"
          id="deletecols"
          tabIndex={-1}
          aria-labelledby="deletecolsLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deletecolsLabel">
                  Delete Column?
                </h1>
                <span data-bs-dismiss="modal" aria-label="Close">
                  <svg
                    width={16}
                    height={15}
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 6.3216L14.0778 0.243764C14.4029 -0.0812545 14.9312 -0.0812545 15.2562 0.243764C15.5813 0.568782 15.5813 1.09714 15.2562 1.42216L9.1784 7.5L15.2562 13.5778C15.5813 13.9029 15.5813 14.4312 15.2562 14.7562C14.9312 15.0813 14.4029 15.0813 14.0778 14.7562L8 8.6784L1.92216 14.7562C1.59714 15.0813 1.06878 15.0813 0.743764 14.7562C0.418745 14.4312 0.418745 13.9029 0.743764 13.5778L6.8216 7.5L0.743764 1.42216C0.418745 1.09714 0.418745 0.568782 0.743764 0.243764C1.06878 -0.0812545 1.59714 -0.0812545 1.92216 0.243764L8 6.3216Z"
                      fill="#323338"
                    />
                  </svg>
                </span>
              </div>
              <div className="modal-body">
                <div className="sheetPopuDivider" />
                <div className="contentAddColsSec d-block deletTextBody">
                  <h6>Are you sure you want to delete this column? </h6>
                  <h6 className="fw-normal">
                    This action cannot be undone, and all data in this column will be
                    lost.
                  </h6>
                </div>
                <div className="d-flex deletButton">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary activeRed">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* start Delete cols Popup  */}
      </>


      <>
        {/* === Start Manage Column ==== */}
        {viewManageColumn && (
        <DragDropContext onDragEnd={onDragEnd}>
          <div
            className="offcanvas offcanvas-end filterSecPopup mangeColsLeadev mangeColsLeadevsetunm show"
            id="manageColRightPopup"
            aria-labelledby="manageColRightLayout"
            ref={offcanvasRef}
            style={{ visibility: "visible", transform: "translateX(0%)", zIndex: 1050 }}
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="manageColRightLayout">
                Manage Column
              </h5>
              <button
                type="button"
                className="btn-close d-none"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body pt-0 learnigPopuMange">
              <div className="assignPopoHeight">
                <div className="selectUniqCols">
                  <div className="selectSec filterStyleSec py-0">
                    <label htmlFor="">Unique Identifier (UID)</label>
                    <select
                      className="searchOption"
                      onChange={handleUidChange}
                      value={uniqueId}
                    >
                      <option value="">Select Unique Identifier Column</option>
                      {columns.map((column, index) => {
                        return <option key={index} value={column.fieldName}>
                          {column.headerValue}
                        </option>
                      })}
                    </select>
                  </div>
                </div>
                <div className="mangeSearchSec magecolslearning">
                  {/* ... search input ... */}
                </div>
                <Droppable droppableId="columns">
                  {(provided) => (
                    <div 
                      {...provided.droppableProps} 
                      ref={provided.innerRef}
                      id="manageColMenu" 
                      className="selectSec py-0"
                    >
                      <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="selectAllmenu"
                          checked={Object.values(columnVisibility).every(Boolean)}
                          onChange={(e) => {
                            const newValue = e.target.checked;
                            const updatedVisibility = Object.fromEntries(
                              Object.keys(columnVisibility).map(key => [key, newValue])
                            );
                            setColumnVisibility(updatedVisibility);
                          }}
                        />
                        <label htmlFor="selectAllmenu">
                          All columns
                        </label>
                      </div>
                      {columns.map((col, index) => (
                        <Draggable 
                          key={col.fieldName} 
                          draggableId={col.fieldName} 
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className="form-group AllFilter_Select py-0 mangeColHoversec"
                            >
                              <div className="d-flex gap-12 align-items-center">
                                <div {...provided.dragHandleProps}>
                                  <svg width={16} height={26} viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                                    <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                                    <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                                    <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                                    <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                                    <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                                    <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                                    <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                                  </svg>
                                </div>

                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`mangCol_${col.order}`}
                                  checked={columnVisibility[col.order] ?? true}
                                  onChange={() => {
                                    setColumnVisibility(prev => ({
                                      ...prev,
                                      [col.order]: !prev[col.order]
                                    }))
                                  }}
                                />
                                <label htmlFor={`mangCol_${col.order}`}>
                                  {col.headerValue || col.order}
                                </label>
                                {col.isUid ? <span className="bgUidBlue">
                                  {/* UID badge ... */}
                                </span> : null}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
              <div className="">
                <button
                  type="button"
                  className="btn btn-primary radius-6 px-14 py-6 text-sm w-100 my-12"
                  onClick={handleSaveView}
                >
                  Save as new view
                </button>
              </div>
            </div>
          </div>
        </DragDropContext>
      )}
        {/* === End Manage Column ==== */}
      </>


    </div >
  )
}

export default LearningDevelopment
